import APIService from './api';
import AuthService from './auth';

const apiService = new APIService();

export { APIService, apiService, AuthService };
